import React from 'react';
import { useTranslation } from 'react-i18next';
import { useQuery } from '@tanstack/react-query';
import { api, pickLocale } from '@/lib/api';
import { useSEO } from '@/lib/useSEO';

export default function Gallery() {
  const { t, i18n } = useTranslation();
  useSEO({ title: 'Gallery', description: 'Photo gallery from UKGM programmes, events and outreach across India.' });
  const lang = i18n.language.split('-')[0];
  const { data: items = [] } = useQuery({ queryKey: ['gallery'], queryFn: async () => (await api.get('/gallery')).data });

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 md:py-24" data-testid="gallery-page">
      <h1 className="font-serif text-4xl md:text-6xl text-ukgm-blue font-semibold leading-tight">{t('gallery.title')}</h1>
      <p className="mt-4 max-w-2xl text-ukgm-slate text-lg">{t('gallery.subtitle')}</p>

      {items.length > 0 && (
        <div className="mt-10 columns-1 sm:columns-2 lg:columns-3 gap-4 [column-fill:_balance]">
          {items.map((g, i) => (
            <figure key={g.id || i} className="break-inside-avoid mb-4 rounded-2xl overflow-hidden border border-ukgm-gold/20 bg-white" data-testid={`gallery-item-${i}`}>
              <img src={g.image_url} alt={pickLocale(g.caption, lang)} className="w-full object-cover" />
              <figcaption className="p-3 text-xs text-ukgm-slate">{pickLocale(g.caption, lang)}</figcaption>
            </figure>
          ))}
        </div>
      )}
    </div>
  );
}
